import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Waiting from './Waiting';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';

import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import { badgeRequest, resetErrorMessage } from '../actions';

const GetNameBadge = ({nameBadgeOpen, setNameBadgeOpen}) => {
	const classes = useStyles();
	const isSm = useMediaQuery('(min-width:650px)');
	
	const dispatch = useDispatch();
	const [submitted, setSubmitted] = useState(false);
	const request = useSelector(state => state.requests.name_badge);

	const resetForm = (close) => {
		dispatch(resetErrorMessage());
		if(close){
			setNameBadgeOpen(false);
		}
		setSubmitted(false);
	}
	
	const submitRequest = () => {
		dispatch(resetErrorMessage());
		setSubmitted(true);
		dispatch(badgeRequest());
	}

	const SubmitResult = () => {
		if(request.submitting){
			return <DialogContent dividers>
				<Waiting message='Generating name badge. Please wait...' />
				</DialogContent>
		} else if(submitted && request.url){
			return <>
			<DialogContent dividers>
				<Typography variant='h6' component='h3' gutterBottom>Success</Typography>
				<Typography paragraph>Your name badge has been generated.</Typography>
				<Button variant='contained' color="primary"
					href={request.url} target="_blank" rel="noreferrer"
				>
				Download name badge
				</Button>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => resetForm(true)} color="primary">Close</Button>
			</DialogActions>
			</>
		} else if(submitted && !request.url) {
			return <>
			<DialogContent dividers>
				<Typography variant='h6' component='h3' gutterBottom>Error</Typography>
				<Typography paragraph>Failed to generate name badge.</Typography>
				<Typography paragraph>{request.message}</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => resetForm(true)} color="primary">
					Close
				 </Button>
				 <Button variant='contained' onClick={() => submitRequest()} color="primary">
					Try Again
				 </Button>
			</DialogActions>
			</>;
		} else {
			return <DialogContent dividers></DialogContent>
		}
	}
	
	return (
	<Dialog
		open={nameBadgeOpen}
		onClose={() => resetForm(true)}
		fullScreen={!isSm}
		aria-labelledby="setings-dialog-title"
		className={classes.settingsDialog}
		>
		<DialogTitle id="settting-dialog-title">Fetch Name Badge</DialogTitle>
		{submitted ? <SubmitResult /> :
		<>
		<DialogContent dividers>
		<Typography>Generate a name badge in Word (.docx) format.</Typography>
		</DialogContent>
		<DialogActions>
		  <Button onClick={() => resetForm(true)} color="primary">
			Cancel
		  </Button>
		  <Button variant='contained' onClick={() => submitRequest()} color="primary" autoFocus>
			Submit
		  </Button>
		</DialogActions>
		</>
		}
	</Dialog>
)}

export default GetNameBadge;